// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-6903d5b2]  .m-t{margin-top:12px}[data-v-6903d5b2]  .footer-left>.v-btn~.v-btn{margin-right:8px}[data-v-6903d5b2]  .footer-right>.v-btn~.v-btn{margin-left:8px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
